import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BootstrapModal as Modal } from '../../components/BootstrapModal/BootstrapModal';
import {
  selectLoginMode,
  selectCurrentPortalName,
} from '../../../ReduxStorage/Auth/selectors';
import {
  cancelLogin,
  selectForgotPassword,
  cancelForgotPassword,
  login,
  setLoginMode,
  resetPassword,
  signUp,
} from '../../../ReduxStorage/Auth/dispatchers';
import { selectIsSSOLoginMode } from '../../../ReduxStorage/BasePage/selectors';
import { selectCurrentCustomDomain } from '../../../ReduxStorage/location/selectors';
import { makeSelectAutoAddNewUsersToPortal } from '../../../ReduxStorage/Portal/selectors';
import { LoginMode } from '../../../ReduxStorage/Auth/Login/constants';
import { LoginSignup } from '../../components/LoginSignup';
import { ModalLoginForm } from '../../components/LoginSignup/LoginForm';
import { ModalSignUpForm } from '../../components/LoginSignup/SignUpForm';
import { ModalResetPasswordForm } from '../../components/LoginSignup/ResetPasswordForm';

import './LoginModal.scss';

class LoginModal extends React.PureComponent {
  static displayName = 'LoginModal';

  static propTypes = {
    loginMode: PropTypes.oneOf([LoginMode.login, LoginMode.signup]),
    forgotPassword: PropTypes.bool.isRequired,
    loginRequired: PropTypes.bool.isRequired,
    managedByInstitution: PropTypes.string,
    isSSOLoginMode: PropTypes.bool.isRequired,
    onCancelLogin: PropTypes.func.isRequired,
    onSelectLogin: PropTypes.func.isRequired,
    onSelectSignup: PropTypes.func.isRequired,
    onForgotPassword: PropTypes.func.isRequired,
    onCancelForgotPassword: PropTypes.func.isRequired,
    onSignUp: PropTypes.func.isRequired,
    onLogin: PropTypes.func.isRequired,
    onResetPassword: PropTypes.func.isRequired,
    isCustomDomain: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    managedByInstitution: null,
    loginMode: LoginMode.login,
  };

  onSignUp = (email, password, fullName, subscribe) => {
    const { managedByInstitution, isSSOLoginMode, onSignUp } = this.props;
    return onSignUp(
      email,
      password,
      fullName,
      subscribe,
      managedByInstitution,
      isSSOLoginMode
    );
  };

  render() {
    const {
      loginMode,
      loginRequired,
      forgotPassword,
      onForgotPassword,
      onCancelForgotPassword,
      isSSOLoginMode,
      onCancelLogin,
      onSelectLogin,
      onSelectSignup,
      onLogin,
      onResetPassword,
      isCustomDomain,
    } = this.props;
    const open = !isSSOLoginMode && loginRequired;

    return (
      <Modal show={open} onHide={onCancelLogin} dialogClassName="login-modal">
        <LoginSignup
          view={forgotPassword ? LoginMode.forgotPassword : loginMode}
          onBackToLoginClick={onCancelForgotPassword}
          {...{
            onSelectLogin,
            onSelectSignup,
          }}
          loginForm={<ModalLoginForm {...{ onForgotPassword, onLogin }} />}
          signUpForm={<ModalSignUpForm onSignUp={this.onSignUp} />}
          resetPasswordForm={
            <ModalResetPasswordForm {...{ onResetPassword }} />
          }
          isCustomDomain={isCustomDomain}
        />
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const auth = state.Auth;
  let managedByInstitution = null;
  const portalName = selectCurrentPortalName(state);
  if (portalName && makeSelectAutoAddNewUsersToPortal(portalName)(state)) {
    managedByInstitution = portalName;
  }
  return {
    loginMode: selectLoginMode(state),
    forgotPassword: auth.get('forgotPassword', false),
    loginRequired: auth.get('loginRequired', false),
    isSSOLoginMode: selectIsSSOLoginMode(state),
    managedByInstitution,
    isCustomDomain: Boolean(selectCurrentCustomDomain(state)),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onCancelLogin: () => dispatch(cancelLogin()),
    onSelectLogin: () => dispatch(setLoginMode(LoginMode.login)),
    onSelectSignup: () => dispatch(setLoginMode(LoginMode.signup)),
    onForgotPassword: () => dispatch(selectForgotPassword()),
    onCancelForgotPassword: () => dispatch(cancelForgotPassword()),
    onLogin: (email, password) => dispatch(login(email, password)),
    onResetPassword: (email) => dispatch(resetPassword(email)),
    onSignUp: (
      email,
      password,
      fullName,
      subscribe,
      managedByInstitution,
      sso
    ) =>
      dispatch(
        signUp(email, password, fullName, subscribe, managedByInstitution, sso)
      ).then(() => dispatch(login(email, password))),
  };
}

export const ConnectedLoginModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginModal);
